<template>
    <div class="project_py">
        <div class="information">
            <span class="information_bar"></span>
            <span class="information_zh">专题专栏</span>
            <span class="information_en">SPECIAL COLUMN</span>
            <div class="more_conent" @click="outbreak()">
                <img src="../images/more.png" alt="">
                <span class="more_py">更多</span>
            </div>
        </div>
       <div class="project">
           <!-- 专题专栏列表 -->
          <div class="column_listsers">
              <div class="column_cont" v-for="item in columnList" :key="item.id" @click="outbreaklist(item)">
                <img :src="item.coverImage" alt="">
                <!-- <el-image :src="item.srcUrl" lazy></el-image> -->
                <p>{{item.name}}</p>
              </div>
          </div>
          <!-- 广告 -->
          <div class="column_adv">
                <a :href="advertisingLists.advertUrl"  target="_blank" style="display:block;height:110px">
                    <span class="column_adver">广告</span>
                    <img :src="'https://www.pyxxww.com:29503' + advertisingLists.imgPath" alt="">
                    <!-- <el-image :src="'http://121.36.11.76:9503' + advertisingLists.imgPath" lazy></el-image> -->
                </a>
          </div>
       </div>
    </div>
</template>
<script>
import {advertisingList , columnList ,getColumnByParentId ,generateSign} from '@/api/index'
import Bus from '@/Bus'
const advertisingParameter = {
    appInfoId:10,
    pageNo:1,
    pageSize:10
}
const obtaincolumnparameter = {
    appInfoId: "10",
    parentId: "148f7fde-4d1d-4f7f-9052-70fce8f62673"
}
export default {
    data(){
        return {
            jumpRouting:true,
            columnList:[
                // {
                //     id:'b2f48823-a449-48e7-91ec-77d88924b0b3',
                //     name:'全国两会',
                //     srcUrl:require('./img/qglh.png')
                // },
                // {
                //     id:'5e3d40cfe4b0a6957ef82267',
                //     name:'抗击疫情',
                //     srcUrl:require('./img/kjyq.jpg')
                // },
                // {
                //     id:'5e804a48e4b027314a1354e9',
                //     name:'教育事业',
                //     srcUrl:require('./img/jysy.jpg')
                // },
                // {
                //     id:'14f8ad46-c35c-414c-827f-deff96f54900',
                //     name:'党的建设',
                //     srcUrl:require('./img/ddjs.jpg')
                // }

            ],
            listParameter: Object.assign({}, advertisingParameter),
            listcolumnparameter: Object.assign({}, obtaincolumnparameter),
            advertisingLists:[],
        }
    },
    created(){
        this.advertisingListFun()
        this.projectObtain()
    },
    methods:{
        outbreak(){
            let routeData = this.$router.resolve({ path: '/columnlist' });
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        outbreaklist(item){
            let routeData = ''
            // if(item.uuid == 'b2f48823-a449-48e7-91ec-77d88924b0b3'){
                routeData = this.$router.resolve({ path: '/contentList' , query: {  title: item.name , listId :item.uuid } });
            // }else{
            //     routeData = this.$router.resolve({ path: '/columnlists' , query: {  title: item.name , listId :item.uuid } });
            // }
            window.open(routeData.href, '_blank');
            Bus.$emit('jumpRouting', false );
        },
        projectObtain(){
            const headers = {
        'Sign': generateSign()
      };
            let listcolumnparameter = {}
            listcolumnparameter.appInfoId="10",
            listcolumnparameter.parentId= "148f7fde-4d1d-4f7f-9052-70fce8f62673"
            this.axios.post(getColumnByParentId,listcolumnparameter,{ headers }).then(res => {
                this.columnList = res.data.data.slice('0','4')
            })
        },
        // obtaincolumn(){
        //     this.axios.post(columnList,this.listcolumnparameter).then(res => {
        //         // this.columnList = res.data.data
        //         console.log(res.data.data,'///////////////')
        //     })
        // },
        advertisingListFun(){
            const headers = {
        'Sign': generateSign()
      };
            this.axios.post(advertisingList,this.listParameter).then(res => {
                this.advertisingLists = res.data.data[0][2][0]
                // console.log(res.data.data[0],'---------------')
            })
        },
    }
}
</script>
<style lang="">
    .project_py{
        margin-top:44px;
        border-top:2px solid rgba(201,3,4,1);
    }
    .project_py .information{
        height:45px;
        line-height:45px;
        border-bottom:1px solid rgba(210,210,210,1);;
    }
    .information  .information_bar{
        margin:0 10px 0 16px;
        border-left:3px solid rgba(201,3,4,1);
    }
    .information .information_zh{
         height:18px;
         color:rgba(201,3,4,1);
         font-size:18px;
         font-weight: bolder;
    }
    .information .information_en{
        font-size: 18px;
        color:#646464;
        font-weight: 400;
        margin-left:10px;
    }
    .project{
        height:424px;
    }
    .project .column_listsers{
        height:218px;
        padding-top:24px;
    }
    .more_conent{
        cursor:pointer;
    }
    .project .column_listsers .column_cont{
        cursor:pointer;
        float:left;
        margin:0 16px;
        width:268px;
        text-align: center;
    }
    .project .column_listsers .column_cont img{
        width:100%;
        height:146px;
        display:block;
    }
    .project .column_listsers .column_cont p{
        font-size: 16px;
        line-height:20px;
        color:#333333;
        padding-top:16px;
    }
    .project .column_adv{
        height:230px;
        position:relative;
    }
    .project .column_adv .column_adver{
        background:rgba(255,255,255,0.1);
        position:absolute;
        height:22px;
        border:1px solid #FFFFFF;
        color:#FFFFFF;
        bottom:60px;
        left:16px;
        border-radius: 5px;
        font-size: 12px;
        line-height: 22px;
        padding:0 10px;
    }
    .project .column_adv img{
        width:100%;
        height:180px;
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/components/projectColumn.vue